<template>
  <!-- the modal -->
  <div
    class="modal fade bd-example-modal-lg show"
    id="myModal"
    role="dialog"
    style="margin-top:50px"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- button start -->
          <button
            class="button-2"
            role="button"
            @click="NextImage(currentIndex, currentImage)"
          >
            Next
            <i class="fa-solid fa-bus"></i>
          </button>

          <!-- button end -->
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
          </button>

          
        </div>
        <div class="modal-body" id="dynamic-content">
          <!-- <img :src="currentImage" class="img-fluid" id="showImage" alt="" /> -->
          <transition name="black-fade" mode="out-in">
    <div class="image-container" :key="currentImage">
      <div class="black-overlay"></div>
      <img :src="currentImage" class="img-fluid" id="showImage" alt="" />
    </div>
  </transition>
        </div>
      </div>
    </div>
  </div>

  <Navbar />

  <div class="home" v-if="!isLoading">
    <!-- <section class="breadcrumb-area bread-bg">
            <div class="breadcrumb-wrap">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-6">
                            <div class="breadcrumb-content">
                                <div class="section-heading">
                                    <h2 style="text-align: center;" class="sec__title text-white">Search Results</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bread-svg-box">
                <svg class="bread-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none"><polygon points="100 0 50 10 0 0 0 10 100 10"></polygon></svg>
            </div>
        </section> -->

    <section
      id="hero"
      class="background-image hero-background-image"
      data-background="url(assets/rev-slider-files/assets/logo22_mysafari.jpg)"
    >
      <div class="opacity-mask" data-opacity-mask="rgba(0, 0, 0, 0.6)">
        <div class="intro_title">
          <h3
            class="mt-0 text-capitalize"
            style="font-weight: 700;font-size: 3rem;"
          >
            <br />
          </h3>
        </div>
      </div>
    </section>

    <main class="mobile-main" style="margin-top: 30px">
      <div class="container margin_60">
        <div class="row">
          <aside class="col-lg-3 child-1"></aside>
          <!--End aside -->
          <div class="col-lg-9 child-2">
            <div id="tools">
              <div class="row">
                <div class="col-md-5 col-sm-3">
                  <div class="styled-select-filters">
                    <select v-model="sort_by" id="sort_price">
                      <option value="" selected>Sort by</option>
                      <option value="price">Price</option>
                      <option value="leaving_time">Leaving time</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-7 col-sm-6 ">
                  <input
                    type="text"
                    v-model="search_buses"
                    class="form-control"
                    placeholder="Filter by Bus Names"
                  />
                </div>
              </div>
            </div>
            <ul class="custom-ul" style="margin-left: 24%;">
              <li class="custom-li">
                <p>Tags:</p>
              </li>
              <li class="custom-li">
                <button
                  class="tag-style button-4"
                  name="button"
                  value="OK"
                  type="button"
                  @click="set_vehicles('all')"
                  style="margin-top: 1%;"
                >
                  All
                </button>
              </li>
              <li class="custom-li">
                <button
                  class="tag-style button-4"
                  name="button"
                  value="OK"
                  type="button"
                  @click="set_vehicles('Luxury')"
                  style="margin-top: 1%;"
                >
                  Luxury
                </button>
              </li>
              <li class="custom-li">
                <button
                  class="tag-style button-4"
                  name="button"
                  value="OK"
                  type="button"
                  @click="set_vehicles('Semi-luxury')"
                  style="margin-top: 1%;"
                >
                  Semi-Luxury
                </button>
              </li>
            </ul>

            <!--/tools -->
            <template v-if="trips.success && matchingTrips.length">
              <div
                v-for="(trip, index) in matchingTrips"
                :key="index"
                class="strip_all_safari_list wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div class="row">
                  <div class="col-lg-4 col-md-4 position-relative">
                    <div v-if="trip.vehicle.images[0]" class="img_list">
                      <!-- <a
                        href="#"
                        @click.prevent="NextImage(index, displayed_img[index])"
                        ><img :src="displayed_img[index]" alt="Image" />
                      </a> -->
                      <!-- <a href="#myModal" role="button" class="btn btn-primary" data-toggle="modal">Launch modal</a> -->
                      <a
                        href="#myModal"
                        data-toggle="modal"
                        @click="NextImage(index, displayed_img[index])"
                      >
                        <img :src="displayed_img[index]" alt="Image" />
                      </a>
                    </div>
                    <div v-else class="img_list">
                      <a href="#" onclick="event.preventDefault();"
                        ><img src="@/assets/images/bus1.jpg" alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="safari_list_desc">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <div class="bus d-flex align-items-center ">
                            <div style="margin-right: 10px">
                              <img
                                class="bus-icon"
                                src="@/assets/icons/bus.svg"
                                width="45"
                                alt=""
                              />
                            </div>
                            <div class="bus-name">
                              <h4 class="mb-0 mt-0" style="font-weight: 700">
                                {{ trip.vehicle.company }}
                              </h4>
                              <p class="mb-0" style="font-weight: 500">
                                {{ trip.vehicle.registration_number }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="text-end mobile-price d-none">
                            <h3
                              class="text-capitalize text-end"
                              style="font-weight: 700;"
                            >
                              Tshs {{ Number(trip.fare).toLocaleString() }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <hr class="mt-2" />
                      <div class="row align-items-center">
                        <div class="col-4">
                          <small>From</small>
                          <h2 class="mb-0 mt-0" style="font-weight: 700">
                            {{ trip.trip_route.start_point_code }}
                          </h2>
                          <p class="mb-1" style="font-weight: 600">
                            {{ trip.trip_route.start_point }}
                          </p>
                          <p style="font-weight: 600">
                            {{ trip.departing_time }}
                          </p>
                        </div>
                        <div class="col-4 text-center">
                          <p class="mb-2 text-center">
                            {{ trip.vehicle["fleet_type"] }}
                          </p>

                          <img
                            class="mobile-img"
                            src="@/assets/icons/to.png"
                            width="100%"
                            alt=""
                          />
                          <p class="mt-2">
                            <b> {{ trip.trip_date }}</b>
                          </p>
                        </div>

                        <div class="col-4 text-end trip-dest">
                          <small>To</small>
                          <h2 class="mb-0 mt-0" style="font-weight: 700">
                            {{ trip.trip_route.end_point_code }}
                          </h2>
                          <p class="mb-1" style="font-weight: 600">
                            {{ trip.trip_route.end_point }}
                          </p>
                          <p style="font-weight: 600">
                            {{ trip.arrival_time }}
                          </p>
                        </div>
                        <ul
                          class="add_info d-flex align-items-center justify-content-center"
                        >
                          <li
                            v-for="(amenit, index) in trip.vehicle.amenites"
                            :key="index"
                            style="padding-left: 10px"
                          >
                            <div class="tooltip_styled tooltip-effect-4">
                              <span class="tooltip-item">
                                <img width="25" :src="amenit.icon" alt=""
                              /></span>

                              <div class="tooltip-content text-center">
                                <strong>{{ amenit.name }}</strong>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-2">
                    <div class="safari-price">
                      <h3 class="text-capitalize" style="font-weight: 700;">
                        Tshs {{ Number(trip.fare).toLocaleString() }}
                      </h3>
                    </div>
                    <div class="price_list">
                      <div>
                        <div class="card-seat">
                          <p
                            class="fw-700 font-lg ls-3 lh-1 text-white mb-0 fw-bold"
                          >
                            <span class="h-seat1" style="color: white;"
                              >Available</span
                            >
                            <span
                              class="ls-1 d-block font-xsss text-white fw-600 h-seat"
                              >{{ trip.remained_seats<0 ? 0:trip.remained_seats }}</span
                            >Seats
                          </p>
                        </div>

                        <a
                          @click="
                            goToDetails(trip.id, trip.trip_route.stations,trip.departing_time)
                          "
                          class="btn_1 btn-book "
                          style="color: white;"
                          >Book Now</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="no_vehicles_template">
              <p>No Vehicles Found</p>
            </template>
          </div>
        </div>
      </div>
    </main>

    <!-- <section class="card-area section--padding">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="filter-wrap margin-bottom-30px">
                            <div class="contact-form-action search-input-group-wrap">
								<div class="row justify-content-center">
									<div class="col-lg-6 pr-0">
										<div class="d-flex align-items-center search-input-group" >
											<div class="input-box flex-grow-1 prepend-input-box" >
											<label class="label-text">From</label>
											<div class="form-group">
												<span class="la la-map-marker form-icon"></span>
												<div class="position-relative w-100">
												<input v-model="journey.from_search" class="form-control prepend-input address-1" type="text" placeholder="Dar es Salaam">
												<div class="position-absolute w-100 bg-white mt-2 overflow-hidden rounded shadow-sm" style="max-height: 15rem; z-index: 10;">
													<ul class="list-unstyled">
													<template v-if="matchingFromRegions.length">
														<li v-for="(region, index) in matchingFromRegions" :key="index" class="px-3 py-2 pe-auto hover:bg-gray-200 text-center">
														<a @click="captureRegion(region,'from')" class="pe-auto d-flex justify-content-start">
															{{ region.name }}
														</a>
														</li>
													</template>
													<li v-else-if="journey.from && !matchingFromRegions.length && capturedRegionName.from != journey.from_search" class="px-3 py-2 text-center">
														No Matching Results
													</li>
													</ul>
												</div>
												</div>
												<button class="icon-switch" type="button">
												<img
													src="data:image/svg+xml;base64,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"
													alt=""
												/>
												</button>
											</div>
											</div>
											<div class="input-box flex-grow-1 append-input-box">
												<label class="label-text">To</label>
												<div class="form-group">
													<span class="la la-map-marker form-icon"></span>
													<div class="position-relative w-100">
														<input v-model="journey.to_search" class="form-control prepend-input address-1" type="text" placeholder="Dar es Salaam">
														 {{ matchingFromRegions.length }} 
														<div class="position-absolute w-100 bg-white mt-2 overflow-hidden rounded shadow-sm" style="max-height: 15rem; z-index: 10;">
															<ul class="list-unstyled">
															<template v-if="matchingToRegions.length">
																<li v-for="(region, index) in matchingToRegions" :key="index" class="px-3 py-2 pe-auto hover:bg-gray-200 text-center">
																<a @click="captureRegion(region,'to')" class="pe-auto d-flex justify-content-start">
																	{{ region.name }}
																</a>
																</li>
															</template>
															<li v-else-if="journey.to && !matchingToRegions.length && capturedRegionName.to != journey.to_search" class="px-3 py-2 text-center">
																No Matching Results
															</li>
															</ul>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-4 pr-0">
										<div class="input-box">
											<label class="label-text">Departure</label>
											<div class="form-group">
											<span class="la la-calendar form-icon"></span>
											<input  v-model="journey.trip_date" class="date-range form-control" type="date"  name="daterange-single"  />
											</div>
										</div>
									</div>
									<div class="col-lg-10">
										<div class="section-tab section-tab-2 pb-2 text-center">
											<ul class="nav nav-tabs justify-content-center" id="myTab3" role="tablist">
												<li class="nav-item">
													<a  class="nav-link" :class="{ 'active': journey.journey_type_id == '1' }"  @click="assignBookingType('1')" id="one-way-tab" data-toggle="tab" role="tab" aria-controls="one-way" aria-selected="true" >
														One way
													</a>
												</li>
												<li class="nav-item">
													<a class="nav-link" :class="{ 'active': journey.journey_type_id == '2' }" id="round-trip-tab" data-toggle="tab"  @click="assignBookingType('2')" role="tab" aria-controls="round-trip" aria-selected="false" >
														Go & Return
													</a>
												</li>
												<li class="nav-item">
													<a class="nav-link" :class="{ 'active': journey.journey_type_id == '3' }" data-toggle="tab" @click="assignBookingType('3')" role="tab" aria-controls="round-trip" aria-selected="false" >
														Private Hire
													</a>
												</li>
											</ul>
										</div>
									</div>
									<div class="col-lg-10">
										<button @click="findBusses()"  class="theme-btn w-100 text-center margin-top-20px" >Search</button>
									</div>
								</div>
								
								
								
							</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="sidebar mt-0">
                            <div class="sidebar-widget">
                                <h3 class="title stroke-shape">Class</h3>
                                <div class="sidebar-category">
                                    <div class="custom-checkbox" v-for="(busClass, index) in bussesClasses" :key="index">
                                        <input type="checkbox" @click="addBusClass(busClass.id)">
                                        <label for="cat1">{{busClass.class}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="sidebar-widget">
                                <h3 class="title stroke-shape">Leaving Tunduma</h3>
                                <div class="sidebar-category">
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat1">
                                        <label for="cat1">5:30 Am</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat2">
                                        <label for="cat2">6:00 Am</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat3">
                                        <label for="cat3">6:30 Am</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat4">
                                        <label for="cat4">7:00 Am</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat5">
                                        <label for="cat5">12:00 Pm</label>
                                    </div>
                                   
                                </div>
                            </div>
                            <div class="sidebar-widget">
                                <h3 class="title stroke-shape">Filter by Price</h3>
                                <div class="sidebar-price-range">
                                    <div class="slider-range-wrap">
                                        <div class="price-slider-amount padding-bottom-20px">
                                            <label for="amount2" class="filter__label">Price:</label>
                                            <input type="text" id="amount2" class="amounts">
                                        </div>
                                        <div id="slider-range2" class="ui-slider ui-corner-all ui-slider-horizontal ui-widget ui-widget-content"><div class="ui-slider-range ui-corner-all ui-widget-header" style="left: 4%; width: 76%;"></div><span tabindex="0" class="ui-slider-handle ui-corner-all ui-state-default" style="left: 4%;"></span><span tabindex="0" class="ui-slider-handle ui-corner-all ui-state-default" style="left: 80%;"></span></div>
                                    </div>
                                    <div class="btn-box pt-4">
                                        <button class="theme-btn theme-btn-small theme-btn-transparent" type="button">Apply</button>
                                    </div>
                                </div>
                            </div>
                            <div class="sidebar-widget">
                                <h3 class="title stroke-shape">Brands</h3>
                                <div class="sidebar-category">
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat1">
                                        <label for="cat1">Kilimanjaro </label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat2">
                                        <label for="cat2">Color Star</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat3">
                                        <label for="cat3">Golden Deer </label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat4">
                                        <label for="cat4">Rungwe Coach</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat5">
                                        <label for="cat5">New Force </label>
                                    </div>
                                </div>
                            </div>
                            <div class="sidebar-widget">
                                <h3 class="title stroke-shape">Amenities</h3>
                                <div class="sidebar-category">
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat1">
                                        <label for="cat1">Toilet </label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat2">
                                        <label for="cat2">A/C</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat3">
                                        <label for="cat3">Backseat TV</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat4">
                                        <label for="cat4">Wi-Fi</label>
                                    </div>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="cat5">
                                        <label for="cat5">Food</label>
                                    </div>
 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <template v-if="trips.success && trips.journeys.length">
                            <div v-for="(trip, index) in trips.journeys" :key="index" class="card-item car-card card-item-list">
                                <div class="card-img padding-top-50px">
                                    <a href="car-single.html" class="d-block">
               
                                        <img src="../assets/images/bus1.jpg" alt="car-img" class="h-100">
                                    </a>
                                    <div class="add-to-wishlist icon-element" data-toggle="tooltip" data-placement="top" title="" data-original-title="Save for later">
                                        <i class="la la-heart-o"></i>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <h3 class="card-title"><a >{{ trip.vehicle.company }}</a></h3>
                                            <p class="card-meta">{{ trip.vehicle.registration_number }}</p>
                                        </div>
                                        <div class="col-md-4">
                                            <h3 class="card-title">Tsh {{ Number(trip.fare).toLocaleString()}}</h3>
                                        </div>
                                    </div>
                                    <hr>                           
                                    <div class="row">
                                        <div class="col-md-9">
                                            <div class="card-price d-flex align-items-center justify-content-between row">
                                                <div class="col-xs-3">
                                                    <span class="price__from">From</span>
                                                    <h1>{{ trip.trip_route.start_point_code }}</h1>
                                                    <span class="price__from">{{ trip.trip_route.start_point }}</span>
                                                    <p class="price__from">{{trip.departing_time}}</p>
                                                </div>
                                                <div class="col-xs-6 text-center">
                                                    <span class="price__from">{{ trip.vehicle.fleet_type }}</span>
                                                    <h6>{{trip.trip_date}}</h6>
                                                </div>
                                                <div class="col-xs-3 text-right">
                                                    <span class="price__from">To</span>
                                                    <h1>{{ trip.trip_route.end_point_code }}</h1>
                                                    <span class="price__from">{{ trip.trip_route.end_point }}</span>
                                                    <p class="price__from">{{ trip.arrival_time }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="card text-white bg-secondary mb-3 text-center">
                                                <p class="card-text text-primary">Available</p>
                                                    <h1>{{trip.remained_seats}}</h1>
                                                    <p class="card-text">Seats</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-8">
                                            
                                            <button class="btn btn-light btn-lg btn-block">
                                                <i v-for="(amenit, index) in trip.vehicle.amenites" :key="index">
                                                    <img class="img-amenite mr-1 ml-1" :src="amenit.icon" alt="">
                                                </i>                                   
                                            </button>
                                        </div>
                                        <div class="col-md-4">
                                            <a @click="goToDetails(trip.id,trip.trip_route.stations)" class="btn btn-primary">Book Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </template>
                        <template v-else>
                            <div class="text-center alert alert-secondary">
                                <div v-if="message">
                                    {{ message }}
                                </div>
                                <div>
                                    No route Available
                                </div>
                                
                            </div>
                        </template>
                        
                    </div>
                </div>
            </div>
        </section> -->
  </div>
  <div class="home" v-else>
    <Loading />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Loading from "@/views/custom/Loading.vue";

export default {
  components: { Navbar, Loading },
  data() {
    return {
      no_vehicles_template: false,
      currentIndex: "",
      currentImage: "",
      imageModal: false,
      isImageViewerOpen: false,
      pic: 0,
      search_buses: "",
      sort_by: "",
      current_page: "",
      currentPage: "Jobs",
      previousPage: "",
      journey: {
        from_search: "",
        from: "",
        to_search: "",
        to: "",
        trip_date: "",
        journey_type_id: "",
      },
      trips: {
        journeys: [],
      },
      obj: "",
      shown_trips: "",
      capturedRegionName: {
        from: localStorage.getItem("from_search"),
        to: localStorage.getItem("to_search"),
      },
      bussesClasses: [
        {
          id: 1,
          class: "Luxury",
        },
        {
          id: 2,
          class: "Semi Luxury",
        },
        {
          id: 3,
          class: "Low Class",
        },
      ],
      departureTime: [
        {
          id: 1,
          name: "Morning",
          time: "5:30 AM",
          value: "5:30",
        },
        {
          id: 2,
          name: "Morning",
          time: "6:00 AM",
          value: "6:30",
        },
        {
          id: 3,
          name: "Morning",
          time: "6:30 AM",
          value: "6:30",
        },
        {
          id: 4,
          name: "Morning",
          time: "7:00 AM",
          value: "7:00",
        },
        {
          id: 5,
          name: "Morning",
          time: "7:30 AM",
          value: "7:30",
        },
        {
          id: 6,
          name: "Morning",
          time: "8:00 AM",
          value: "8:00",
        },
        {
          id: 7,
          time: "8:30 AM",
          value: "8:30",
        },
        {
          id: 8,
          name: "Morning",
          time: "9:00 AM",
          value: "9:00",
        },
        {
          id: 9,
          name: "Morning",
          time: "9:30 AM",
          value: "9:30",
        },
        {
          id: 10,
          name: "Morning",
          time: "10:00 AM",
          value: "10:00",
        },
        {
          id: 11,
          name: "Morning",
          time: "10:30 AM",
          value: "10:30",
        },
        {
          id: 12,
          name: "Morning",
          time: "11:00 AM",
          value: "11:30",
        },
        {
          id: 13,
          name: "Morning",
          time: "11:30 AM",
          value: "11:30",
        },
        {
          id: 14,
          name: "Noon",
          time: "12:00 PM",
          value: "12:00",
        },
        {
          id: 15,
          name: "Afternoon",
          time: "12:30 PM",
          value: "12:30",
        },
        {
          id: 16,
          name: "Afternoon",
          time: "1:00 AM",
          value: "13:00",
        },
        {
          id: 17,
          name: "Afternoon",
          time: "1:30 PM",
          value: "13:30",
        },
        {
          id: 18,
          name: "Afternoon",
          time: "2:00 PM",
          value: "14:00",
        },
        {
          id: 19,
          name: "Afternoon",
          time: "2:30 PM",
          value: "14:30",
        },
        {
          id: 20,
          name: "Afternoon",
          time: "3:00 PM",
          value: "15:00",
        },
        {
          id: 21,
          name: "Afternoon",
          time: "3:30 PM",
          value: "15:30",
        },
        {
          id: 22,
          name: "Evening",
          time: "4:00 PM",
          value: "16:00",
        },
        {
          id: 23,
          name: "Evening",
          time: "4:30 PM",
          value: "16:30",
        },
        {
          id: 24,
          name: "Evening",
          time: "5:00 PM",
          value: "17:00",
        },
        {
          id: 25,
          name: "Evening",
          time: "5:30 PM",
          value: "17:30",
        },
        {
          id: 26,
          name: "Evening",
          time: "6:00 PM",
          value: "18:00",
        },
      ],
      bussesBrands: [
        {
          id: 1,
          name: "Abood",
        },
        {
          id: 2,
          name: "Shabiby",
        },
        {
          id: 3,
          name: "ABC Upper Class",
        },
        {
          id: 4,
          name: "Tashiff",
        },
        {
          id: 5,
          name: "kilimanjaro",
        },
      ],
      animates: [
        {
          id: 1,
          name: "Toilets",
        },
        {
          id: 2,
          name: "A/C",
        },
        {
          id: 3,
          name: "Backseat TV",
        },
        {
          id: 4,
          name: "WiFi",
        },
        {
          id: 5,
          name: "Food",
        },
      ],

      regions: {},
      isLoading: true,
      jobs: { current_page: 1 },
      allJobs: {},
      data: {},
      errors: false,
      classes: ["d-none"],
      busArray: {},
      imageArray: [],
      displayed_img: [],
    };
  },
  methods: {
    test() {
      console.log("test");
    },
    openModal(image) {
      // Emit an event to send the image to the parent component (e.g., Navbar.vue)
      this.$emit("open-modal", image);
      console.log(image);
    },
    openImageViewer(index) {
      this.currentImageIndex = index;
      this.isImageViewerOpen = true;
    },
    busImages(val) {
      console.log(val);
      if (val === "initial") {
        this.imageArray = [];
        this.displayed_img = [];

        console.log(this.busArray.journeys.length);

        const journeyCount = this.busArray.journeys.length;

        for (let i = 0; i < journeyCount; i++) {
          const journey = this.busArray.journeys[i];
          const imagesCount = journey.vehicle.images.length;

          const journeyNumber = i + 1;

          // Create an object for the journey
          const journeyObject = {
            journey: journeyNumber,
            images: [],
          };

          for (let j = 0; j < imagesCount; j++) {
            const image = journey.vehicle.images[j].image;

            // Use the image URL as the "id" property
            journeyObject.images.push({
              id: image,
            });
          }

          this.imageArray.push(journeyObject);

          // Check if journeyObject is empty and add an empty string to displayed_img
          if (journeyObject.images.length > 0) {
            this.displayed_img.push(journeyObject.images[0].id);
          } else {
            this.displayed_img.push(""); // Add an empty string
          }
        }

        console.log(this.imageArray);
        console.log(this.displayed_img);
      }
    },
    closeImageViewer() {
      this.isImageViewerOpen = false;
    },
    NextImage(index, imageUrl) {
      // Find the journey object in imageArray at the specified index
      const journeyObject = this.imageArray[index];

      if (journeyObject) {
        // Find the index of the current imageUrl in the images array of the journeyObject
        const imageIndex = journeyObject.images.findIndex(
          (image) => image.id === imageUrl
        );

        if (imageIndex !== -1) {
          // Calculate the next image index and check if it's within bounds
          const nextImageIndex = (imageIndex + 1) % journeyObject.images.length;

          // Update the displayed_img array with the next URL
          this.displayed_img[index] = journeyObject.images[nextImageIndex].id;

          this.currentImage = this.displayed_img[index];
          this.currentIndex = index;
        }
      }
    },
    set_vehicles(val) {
      if (val == "all") {
        this.shown_trips = this.trips;
      } else if (val == "Luxury") {
        //filtering to luxury trips::
        this.shown_trips = this.trips.journeys.filter(
          (journey) => journey.vehicle.fleet_type === "Luxury"
        );

        if (this.shown_trips.length === 0) {
          // Handle the case where there are no luxury cars
          this.shown_trips = "empty";
        }
      } else if (val == "Semi-luxury") {
        //  filtering to semi-luxury trips::
        this.shown_trips = this.trips.journeys.filter(
          (journey) => journey.vehicle.fleet_type === "Semi Luxury"
        );
        if (this.shown_trips.length === 0) {
          // Handle the case where there are no luxury cars
          this.shown_trips = "empty";
        }
      }
    },
    goToDetails(id, stations,departureTime) {
      localStorage.setItem("stations", JSON.stringify(stations));
      localStorage.setItem("departureTime", JSON.stringify(departureTime));
      this.$router.push({ name: "Booking", params: { id: id } });
    },
    getRegions() {
      axios
        .get("/passenger/regions")
        .then((response) => {
          this.regions = response.data.regions;
        })
        .catch((errors) => {
          this.CountryErrors = error.response.data.errors;
        })
        .finally(() => {
          setTimeout(
            function() {
              this.isLoading = false;
            }.bind(this),
            20
          );
        });
    },
    captureRegion(region, action) {
      if (action == "to") {
        this.journey.to = region.id;
        this.journey.to_search = region.name;
        this.matchingToRegions = [];
        this.capturedRegionName.to = region.name;
      } else {
        this.journey.from = region.id;
        this.journey.from_search = region.name;
        this.matchingFromRegions = [];
        this.capturedRegionName.from = region.name;
      }
    },
    assignBookingType(journey_type_id) {
      this.journey.journey_type_id = journey_type_id;
    },
    findBusses() {
      this.no_vehicles_template = false;
      // if (this.journey.journey_type_id && this.journey.to && this.journey.from) {
      if (this.capturedRegionName.from == this.journey.from_search) {
        localStorage.setItem("from", this.journey.from);
        localStorage.setItem("from_search", this.journey.from_search);
      }
      if (this.capturedRegionName.to == this.journey.to_search) {
        localStorage.setItem("to", this.journey.to);
        localStorage.setItem("to_search", this.journey.to_search);
      }
      if (this.journey.trip_date) {
        localStorage.setItem("trip_date", this.journey.trip_date);
      }
      localStorage.setItem("journey_type_id", this.journey.journey_type_id);

      axios
        .post("/passenger/search-trips", this.journey)
        .then((response) => {
          if (response.data.success) {
            this.trips = response.data;
            this.busArray = response.data;
            this.busImages("initial");

            if (response.data.message) {
              this.no_vehicles_template = true;
              this.message = response.data.message;
            }
          }else{
            this.no_vehicles_template = true;
          }

        })
        .catch((errors) => {
          this.CountryErrors = error.response.data.errors;
        });
    },
    filterTime(leaving_time) {
      let listOfLeavingTime = [leaving_time]; // Create an array with the leaving_time value
      this.matchingTrips = this.matchingTrips.filter((trip) => {
        return listOfLeavingTime.includes(trip.departing_time); // Check if the departing_time is included in the listOfLeavingTime array
      });
    },
  },
  computed: {
    matchingTrips: function() {
      var self = this;
      if (this.shown_trips.length > 0) {
        if (this.shown_trips == "empty") {
          return (this.obj = "");
        } else {
          this.obj = this.shown_trips;

          if (this.obj.length) {
            this.busImages();
            return this.obj.filter(function(obj) {
              return (
                obj.vehicle.name
                  .toLowerCase()
                  .indexOf(self.search_buses.toLowerCase()) !== -1
              );
            });
          }
        }
      } else {
        this.obj = this.trips;
      }

      // check
      if (this.obj.journeys.length && this.search_buses) {
        //
        return this.obj.journeys.filter(function(journey) {
          return (
            journey.vehicle.name
              .toLowerCase()
              .indexOf(self.search_buses.toLowerCase()) !== -1
          );
        });
      } else {
        return this.obj.journeys;
      }
    },
    matchingToRegions: function() {
      var self = this;
      if (
        this.regions.length &&
        this.journey.to_search &&
        this.capturedRegionName.to != this.journey.to_search
      ) {
        return this.regions.filter(function(regionFilter) {
          return (
            regionFilter.name
              .toLowerCase()
              .indexOf(self.journey.to_search.toLowerCase()) !== -1 ||
            regionFilter.code
              .toLowerCase()
              .indexOf(self.journey.to_search.toLowerCase()) !== -1
          );
        });
      } else {
        return {};
      }
    },
  },
  mounted() {
    if (localStorage.getItem("from_search")) {
      this.journey.from_search = localStorage.getItem("from_search");
    }
    if (localStorage.getItem("from")) {
      this.journey.from = localStorage.getItem("from");
    }
    if (localStorage.getItem("to_search")) {
      this.journey.to_search = localStorage.getItem("to_search");
    }
    if (localStorage.getItem("to")) {
      this.journey.to = localStorage.getItem("to");
    }
    if (localStorage.getItem("trip_date")) {
      this.journey.trip_date = localStorage.getItem("trip_date");
    }
    if (localStorage.getItem("journey_type_id")) {
      this.journey.journey_type_id = localStorage.getItem("journey_type_id");
    }
    this.getRegions();
    this.findBusses();

    // create images array:

    document.title = `Search`;
    // this.findBusses()
  },
};
</script>

<style scoped>
hr {
  border: none;
  border-top: 1px dotted #000;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 99%;
}
.img-amenite {
  max-height: 25px;
}

#hero {
  position: relative;
  height: 250px;
}

.intro_title {
  padding-bottom: 0rem !important;
}
col-4 img {
  /*            width: 100px !important;*/
}

.trip-dest p {
  text-align: right !important;
}
.mobile-img {
  width: 120px !important;
}

.hero-background-image {
  background-image: var(--background-image);
}

/* custom tags */
.custom-ul {
  list-style: none;
}

.custom-li {
  display: inline-block;
  margin-right: 10px; /* add spacing between items */
}

.tag-style {
  border-radius: 12px;
}

/* Tag button customization starts here */

/* CSS */
.button-4 {
  appearance: none;
  background-color: #fafbfc;
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 6px;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0,
    rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  box-sizing: border-box;
  color: #24292e;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  list-style: none;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  word-wrap: break-word;
}

.button-5 {
  appearance: none;
  background-color: #fafbfc;
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 6px;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0,
    rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  color: #24292e;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, "Segoe UI", Helvetica, Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  list-style: none;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  word-wrap: break-word;
}

.button-4:hover {
  background-color: #f3f4f6;
  text-decoration: none;
  transition-duration: 0.1s;
}

.button-4:disabled {
  background-color: #fafbfc;
  border-color: rgba(27, 31, 35, 0.15);
  color: #959da5;
  cursor: default;
}

.button-4:active {
  background-color: #edeff2;
  box-shadow: rgba(225, 228, 232, 0.2) 0 1px 0 inset;
  transition: none 0s;
}

.button-4:focus {
  outline: 1px transparent;
}

.button-4:before {
  display: none;
}

.button-4:-webkit-details-marker {
  display: none;
}

/* the filter button */
.button-container {
  width: 100%; /* Ensures the container spans the full width of its parent */

  /* Centers the button vertically */
}
/* For larger screens (e.g., desktops) */
@media screen and (min-width: 581px) {
  /* Adjust the search button to stay filled in its space */
  .button-5 {
    background-color: var(--background-color2);
    color: black;
  }
}

/* For smaller screens (e.g., mobile devices) */
@media screen and (max-width: 767px) {
  /* Force the search button to take the full width of the container and appear on the next line */
  .bt_filters {
    display: block;
    text-align: center;
  }
  .bt_filters button {
    width: 100%;
  }
}

/* style for the no vehicle card */
body {
  font-family: "Oxygen", sans-serif;
  color: #050505;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.main {
  max-width: 1200px;
  margin: 0 auto;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.cards_item {
  display: flex;
  padding: 1rem;
}

.card_image {
  position: relative;
  max-height: 250px;
}

.card_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card_price {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  border-radius: 0.25rem;
  background-color: #c89b3f;
  font-size: 18px;
  font-weight: 700;
}

.card_price span {
  font-size: 12px;
  margin-top: -2px;
}

.note {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 4px 8px;
  border-radius: 0.25rem;
  background-color: #c89b3f;
  font-size: 14px;
  font-weight: 700;
}

@media (min-width: 40rem) {
  .cards_item {
    width: 50%;
  }
}

@media (min-width: 56rem) {
  .cards_item {
    width: 33.3333%;
  }
}

.card {
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card_content {
  position: relative;
  padding: 16px 12px 32px 24px;
  margin: 16px 8px 8px 0;
  max-height: 290px;
  overflow-y: scroll;
}

.card_content::-webkit-scrollbar {
  width: 8px;
}

.card_content::-webkit-scrollbar-track {
  box-shadow: 0;
  border-radius: 0;
}

.card_content::-webkit-scrollbar-thumb {
  background: #c89b3f;
  border-radius: 15px;
}

.card_title {
  position: relative;
  margin: 0 0 24px;
  padding-bottom: 10px;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}

.card_title::after {
  position: absolute;
  display: block;
  width: 50px;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #c89b3f;
  content: "";
}

hr {
  margin: 24px auto;
  width: 50px;
  border-top: 2px solid #c89b3f;
}

.card_text p {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.5;
}

.card_text p:last-child {
  margin: 0;
}

/* the modal style */
@media (min-width: 683px) {
  /* Styles for screens with a width above 992 pixels */
  .modal-dialog {
    max-width: 50%; /* Adjust the maximum width as needed */
  }
}

/* next button style */

/* Base styles for the button */
.button-2 {
  background-color: var(--next-button-color);
  border-radius: 12px;
  color: #000;
  cursor: pointer;
  font-weight: bold;
  padding: 10px 15px;
  text-align: center;
  transition: 200ms;
  width: 15%;
  box-sizing: border-box;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

/* Styles for smaller devices (e.g., mobile) */
@media (min-width: 1242px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 13px;
  }
}

@media (max-width: 1241px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 13px;
  }
}

@media (max-width: 377px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 12px;
  }
}

@media (max-width: 346px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 11px;
  }
}

@media (max-width: 330px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 10px;
  }
}

@media (max-width: 280px) {
  .button-2 {
    width: 25%; /* Make the button full width */
    font-size: 07px;
  }
}


/* Styles for when the button is disabled */
.button-2:disabled {
  filter: saturate(0.2) opacity(0.5);
  -webkit-filter: saturate(0.2) opacity(0.5);
  cursor: not-allowed;
}

/* transition style */
.black-fade-enter-active, .black-fade-leave-active {
  transition: opacity 0.5s;
}

.black-fade-enter, .black-fade-leave-to {
  opacity: 0;
}

.image-container {
  position: relative;
}

.black-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 /* Adjust the background color and opacity as desired */
}


</style>
